// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cognito_identity_pool_id': 'us-east-1:ebeaf36c-db2c-45e9-8997-30a6f31dd150',
    'aws_cognito_region': 'us-east-1',
    'aws_mobile_analytics_app_id': '6167b95a8a2243f0abccefc6e9208d15',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'db9a355c-6fae-4d92-af1b-af1bb76b8ec8',
    'aws_project_name': 'propbets',
    'aws_project_region': 'us-east-1',
    'aws_resource_name_prefix': 'propbets-mobilehub-860423246',
    'aws_sign_in_enabled': 'enable',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_hRv6QLlm1',
    'aws_user_pools_web_client_id': '3moveur8omkt2fjjp4m7l1jgj0',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js